var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 41,
    viewBox: "0 0 56 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_1636_6273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 40.8578C21.3354 40.9245 20.6679 40.958 20 40.958C14.6957 40.958 9.60859 38.8509 5.85786 35.1001C2.10714 31.3494 0 26.2623 0 20.958C0 15.6537 2.10714 10.5666 5.85786 6.81587C9.60859 3.06514 14.6957 0.958008 20 0.958008C20.6679 0.958008 21.3354 0.991467 22 1.05826V7.05826C21.3366 6.97715 20.6682 6.94364 20 6.95801C16.287 6.95801 12.726 8.433 10.1005 11.0585C7.475 13.684 6 17.245 6 20.958C6 24.671 7.475 28.232 10.1005 30.8575C12.726 33.483 16.287 34.958 20 34.958C20.6682 34.9724 21.3366 34.9389 22 34.8578V40.8578Z",
    fill: "#01A5AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 40.8578C55.3354 40.9245 54.6679 40.958 54 40.958C48.6957 40.958 43.6086 38.8509 39.8579 35.1001C36.1071 31.3494 34 26.2623 34 20.958C34 15.6537 36.1071 10.5666 39.8579 6.81587C43.6086 3.06514 48.6957 0.958008 54 0.958008C54.6679 0.958008 55.3354 0.991467 56 1.05826V7.05826C55.3366 6.97715 54.6682 6.94364 54 6.95801C50.8079 6.95775 47.7116 8.04831 45.2243 10.0489C42.737 12.0496 41.0081 14.8401 40.3241 17.958H52V23.958H40.3241C41.0081 27.0759 42.737 29.8665 45.2243 31.8671C47.7116 33.8677 50.8079 34.9583 54 34.958C54.6682 34.9724 55.3366 34.9389 56 34.8578V40.8578Z",
    fill: "#01A5AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1636_6273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    fill: "white",
    transform: "translate(0 0.958008)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCe);
export default __webpack_public_path__ + "static/media/CE.886cee482d4c21b53dfd63a1ecfca513.svg";
export { ForwardRef as ReactComponent };